/* eslint-disable react-hooks/exhaustive-deps */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { useEffect, useState } from 'react';
import "./fonts/style.scss";
import './App.scss';
import Header from './components/header/header';
import ImsWebHelper from "./ims/imswebhelper";
import { ImsData } from "./ims/ims-data";
import Help from './components/help/help';
import Home from './components/home/home';
import Cloud from './components/cloud/cloud';
import Events from './components/events/events';
import EventSubscription from './components/eventSubscription/eventSubscription';
import Footer from './components/footer/footer';
import enlocales from "./locales/en.json";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import { LocaleService } from './models/locale-service';
import ManageSubscription from './components/managesubscription/managesubscription';
import PnsUnsubscribeAll from './components/pnsunsubscribeall/pnsunsubscribeall';
import UnSubscribeProduct from './components/unsubscribeproduct/unsubscribeproduct';
import ProactiveNotification from './components/proactivenotification/proactivenotification';
import SlackLanding from './components/slack/slacklanding';
import SlackError from './components/slack/error';
import SlackSuccess from './components/slack/success';
import { ImsWebConstants, IMS_EVENT, OMEGA_ENV, SHOW_CHATBOT} from './constants';
import HistoryRedirection from './components/historyRediretcion/historyRediretcion';

import Chatbot from 'react-chatbot-kit';
// import config from "./chatbot/config";
import ActionProvider from "./components/home/chatbot/ActionProvider";
import MessageParser from "./components/home/chatbot/MessageParser";
import HelpEvents from './components/helpEvents/helpEvents';
import CFSNew from './components/cfsnew/cfsnew';
// import { useChatbot, ChatbotProvider } from "./components/home/chatbot/ChatbotControllerContext";
import { ButtonRegistryProvider } from "./ButtonRegistryContext";

// Remove the global interface declaration that's causing errors
export const ConfigContext = React.createContext<any>({});

// Create AppContent component to use hooks within ChatbotProvider
function AppContent() {
  const [appConfig, setAppConfig] = useState({
    languageData: enlocales,
    menu: 'Overview'
  });
  const IMSEvent = new Event(IMS_EVENT);

  const locales: any = LocaleService.init();

  const [loggedIn, setLoggedIn] = useState(false);
  const [showBot, setShowBot] = useState(false);
  const [initialChatMessage, setInitialChatMessage] = useState("");

  // Get chatbot context values with null check
  // const { isChatOpen, workflow, openChatWithWorkflow = (workflowName?: string) => {} } = useChatbot() || {};

  function updateMenu(menu: any) {
    setAppConfig({
      languageData: locales?.localeData || enlocales,
      menu: menu
    });
  }
  const context: any = {
    updateMenu,
    appConfig,
    showBot,
    setShowBot
  };
  const onStateChanged = (state: any) => {
    if (state.isSignedInUser) {
      window.adobeIMS?.validateToken();
      window.adobeIMS?.getProfile()
        .then((profile: any) => sessionStorage.setItem('adobeid_ims_profile', JSON.stringify(profile)));
    }
    if (state?.ready) {
      if (state.isSignedInUser) {
        window.adobeIMS?.validateToken().catch(() => {
          window.adobeid.redirect_uri = window.location.href;
          window.adobeIMS?.signIn();
        });
      }
      document.dispatchEvent(IMSEvent);
    }
  };

  useEffect(() => {
    var currentLocaleData = locales.fetch();
    const imsData = new ImsData(onStateChanged);
    window.adobeid = imsData.adobeIdData;
   
    // Expose setShowBot and setInitialChatMessage globally for Home component to access
    // TypeScript-safe method using type assertion
    (window as any).setShowBotState = setShowBot;
    (window as any).setInitialChatMessage = setInitialChatMessage;

    
    if (window?.adobeIMS) {
      getIMS();
    } else {
      document.addEventListener(IMS_EVENT, getIMS);
    }
    const pageDetail = {
      solution: {
        name: "status",
        version: "2022.3"
      },
      env: OMEGA_ENV,
      autoTrack: false
    };
    window.digitalData = {
      user: {
        id: "anonymous",
        corpId: "anonymous",
        corpName: "anonymous",
        authSystem: "anonymous",
        accountType: "anonymous",
        language: window.locale || "en:us"
      },
      page: pageDetail
    };

function getIMS(){

    if(window.adobeIMS?.isSignedInUser()){
      setLoggedIn(true);
    }
}
    // ImsWebHelper.addScript(ImsWebConstants.fedGlobalNavPolyfills);
    // ImsWebHelper.addScript(ImsWebConstants.fedGlobalNav);

    ImsWebHelper.injectAdobeIms().then(() => {
      ImsWebHelper.IMSLoaded();
      ImsWebHelper.addScript(ImsWebConstants.omegaLocation).then(() => {
        if (window._satellite) { // OMEGA tigger
          window._satellite.pageBottom();
        }
      });

    });

    locales.setLocales(currentLocaleData);
    setAppConfig({
      languageData: currentLocaleData,
      menu: 'Overview',
    });

  }, []);

  // Listen for initialChatMessage changes to set the chatbot's initial message
  useEffect(() => {
    if (initialChatMessage && showBot) {
      try {
        // Call openChatWithWorkflow without arguments if it's causing an error
        // openChatWithWorkflow("findEvents");
      } catch (err) {
        console.error("Error opening chat with workflow:", err);
      }
      // Reset after processing
      setTimeout(() => {
        setInitialChatMessage("");
      }, 500);
    }
  }, [initialChatMessage, showBot]);

  return (
    <div className="App">
      
      <Router>
        <ConfigContext.Provider value={context}>
          <Header />
          <Switch>
            {/* <Route path="/cloud/:cloudName">
              <Cloud />
            </Route> */}
            <Route path="/cloud/:cloudName/:eventId?">
              <Cloud />
            </Route>
            {/* <Route path="/:locale/cloud/:cloudName">
              <Cloud />
            </Route> */}
            <Route path="/:locale/cloud/:cloudName/:eventId?">
              <Cloud />
            </Route>
            {/* <Route path="/products/:productId/:eventId?">
              <Events />
            </Route> */}

             <Route
                    path="/products/:productId/:eventId?"
                    render={({ match }) => (
                        <Events key={`${match.params.productId}-${match.params.eventId}`} /> // Dynamically set key
                    )}
                />
            <Route path="/:locale/products/:productId/:eventId?">
              <Events />
            </Route>
            <Route path="/history/:messageId">
              <HistoryRedirection />
            </Route>
            <Route path="/subscribe/:eventId/cloud/:cloudId?">
              <EventSubscription type="subscription" />
            </Route>
            <Route path="/:locale/subscribe/:eventId/cloud/:cloudId?">
              <EventSubscription type="subscription" />
            </Route>
            <Route path="/unsubscribe/:eventId/cloud/:cloudId?">
              <EventSubscription type="unsubscription" />
            </Route>
            <Route path="/:locale/unsubscribe/:eventId/cloud/:cloudId?">
              <EventSubscription type="unsubscription" />
            </Route>
            <Route path="/subscribe/:eventId/:productId?">
              <EventSubscription type="subscription" />
            </Route>
            <Route path="/:locale/subscribe/:eventId/:productId?">
              <EventSubscription type="subscription" />
            </Route>
            <Route path="/unsubscribe/:eventId/:productId?">
              <EventSubscription type="unsubscription" />
            </Route>
            <Route path="/:locale/unsubscribe/:eventId/:productId?">
              <EventSubscription type="unsubscription" />
            </Route>
            <Route path="/proactive-notifications/manage">
              <ManageSubscription />
            </Route>
            <Route path="/:locale/proactive-notifications/manage">
              <ManageSubscription />
            </Route>
            <Route path="/proactive-notifications/subscriptions/:type">
              <ProactiveNotification />
            </Route>
            <Route path="/:locale/proactive-notifications/product/unsubscribe-all">
              <PnsUnsubscribeAll />
            </Route>
            <Route path="/proactive-notifications/product/unsubscribe-all">
              <PnsUnsubscribeAll />
            </Route>
            <Route path="/:locale/proactive-notifications/product/unsubscribe-all">
              <PnsUnsubscribeAll />
            </Route>
            <Route path="/proactive-notifications/product/unsubscribe/:productId">
              <UnSubscribeProduct />
            </Route>
            <Route path="/:locale/proactive-notifications/product/unsubscribe/:productId">
              <UnSubscribeProduct />
            </Route>
            <Route path="/slack/landing">
              <SlackLanding />
            </Route>
            <Route path="/:locale/slack/landing">
              <SlackLanding />
            </Route>
            <Route path="/slack/error">
              <SlackError />
            </Route>
            <Route path="/:locale/slack/error">
              <SlackError />
            </Route>
            <Route path="/slack/success">
              <SlackSuccess />
            </Route>
            <Route path="/:locale/slack/success">
              <SlackSuccess />
            </Route>
            <Route path="/help/proactivesubscriptions" >
              <Help />
            </Route>
            <Route path="/:locale/help/proactivesubscriptions" >
              <Help />
            </Route>
            <Route path="/help/eventglossary" >
              <HelpEvents />
            </Route>
            <Route path="/:locale/help/eventglossary" >
              <HelpEvents />
            </Route>
            {/* <Route path="/help/cfs" >
              <CFSEvents />
            </Route>
            <Route path="/:locale/help/cfs" >
              <CFSEvents />
            </Route> */}
            {/* <Route path="/help/cfs" >
              <CFSNew />
            </Route>
            <Route path="/:locale/help/cfs" >
              <CFSNew />
            </Route> */}


            <Route path="/nav" >
              <Home />
            </Route>
            <Route path="/:locale/nav" >
            </Route>
            <Route path="/:locale/:eventId?" >
              <Home />
            </Route>      
            <Route path="/" exact>
              <Home />
            </Route>
          </Switch>
          
          {/* Chatbot moved after content to appear later in tab order */}
          <div className="chatbot-div">
              { 
                (JSON.parse(SHOW_CHATBOT) && loggedIn) && (
                  <>
                    {showBot ? (
                      <div className="chatbot" tabIndex={-1} id="chatbot-container">
                        <div style={{ maxWidth: "300px" }}>
                          <Chatbot
                            config={require('./components/home/chatbot/config.js').default}
                            actionProvider={ActionProvider}
                            messageParser={MessageParser}
                            headerText='Adobe Status Virtual Assistant'
                          />
                        </div>
                      </div>
                    ) : null}
                    <button 
                      className={showBot ? "chatbot-button active" : "chatbot-button"}
                      onClick={() => {
                        const wasOpen = showBot;
                        setShowBot(!showBot);
                        
                        // When opening the chatbot, focus the message container
                        if (!wasOpen) {
                          // Give it a longer timeout to ensure the chatbot is fully rendered
                          setTimeout(() => {
                            // Specifically target the message container as requested
                            const messageContainer = document.querySelector('.react-chatbot-kit-chat-message-container');
                            if (messageContainer) {
                              // Make it programmatically focusable
                              (messageContainer as HTMLElement).tabIndex = -1;
                              (messageContainer as HTMLElement).focus();
                              return;
                            }
                          }, 300); // Timeout to ensure rendering is complete
                        }
                      }}
                      aria-label={showBot ? "Close virtual assistant" : "Open virtual assistant"}
                      aria-expanded={showBot}
                    >
                      <span className="visually-hidden">{showBot ? "Close" : "Open"} virtual assistant</span>
                    </button>
                  </>
                )
              }
          </div>
          
          <Footer />
        </ConfigContext.Provider>
      </Router>
    </div>
  );
}

// Main App component that provides the ChatbotProvider
function App() {
  return (
    // <ChatbotProvider>
      <ButtonRegistryProvider>
        <AppContent />
      </ButtonRegistryProvider>
    // </ChatbotProvider>
  );
}

export default App;
